/**
 * Default `args` per rule template, seeded when a template is picked — and on a
 * template SWITCH, which now resets args instead of keeping the previous
 * template's keys (the old keep-stale-keys behaviour is how range rules ended up
 * saved without `comparison`, and tpl-39 rules without `delta`).
 *
 * Mirrors the backend schema's `default_args` (backend
 * demo/lib/events/rule_schema.py) and the console's `ruleCatalog.defaultArgs`;
 * src/notifications/ruleSchema.test.js asserts the three agree.
 */

const DEFAULT_ARGS = {
    8: { country: [] },
    43: { country: [] },
    9: { lang: null },
    10: { ota: [], unique_emails: 0, direct: 0, app_promotion: 0 },
    31: { affected_fields: [] },
    32: { update_sources: [] },
    35: { survey_state: [] },
    37: { rebooking: { from: false, to: false } },
    38: { match_all: true, fields: [] },
    39: { raw_delta: '0', unit: 3600, delta: 0 },
    42: { raw_delta: '0', unit: 3600, delta: 0 },
    40: { no_review: false, positive_review: false, negative_review: false },
    41: { latitude: '', longitude: '', radius: '', fetch_method: 'gps' },
    44: { low: 0, high: 5 },
    45: {
        same_departure: false,
        same_tour: false,
        time: { future: false, active: false, past: false },
        time_ref: { future: 'now', active: 'now', past: 'now' },
        tours: [],
        tour_tags: { match_mode: 'and', tags: [] },
    },
    49: { events: [] },
    56: { delivery_methods: [], allow_undefined: false },
    58: { sources: [] },
    59: { future: false, future_delta: 0, present: false, low_delta: 0, high_delta: 0, past: false, past_delta: 0 },
    60: { precheckin_statuses: [] },
    61: { email_receipt: false },
    62: { settlement_method: [] },
    66: { scope: 'any' },
    67: { input: '', comparison: 'any_between', from: null, to: null, tz: 'utc' },
    68: { input: '', comparison: 'any_between', from: null, to: null, tz: 'utc' },
    69: { input: '', comparison: 'any_between', from: null, to: null, tz: 'utc' },
};

// Tag-category / tag rules (all sources).
[33, 50, 52, 54, 71, 73].forEach((tpl) => { DEFAULT_ARGS[tpl] = { tag_categories: [] }; });
[34, 51, 53, 55, 72, 74].forEach((tpl) => { DEFAULT_ARGS[tpl] = { tags: [] }; });

/** A fresh copy of the template's default args (null for templates with none). */
export function defaultArgsFor(tpl) {
    const value = DEFAULT_ARGS[tpl];
    return value === undefined ? null : JSON.parse(JSON.stringify(value));
}

export const DEFAULT_ARGS_TPLS = Object.keys(DEFAULT_ARGS).map(Number);
